class SearchAutocompleteService {

    constructor($http) {
        'ngInject';

        this.$http = $http;
    }

    matches(query) {
        return this.$http.get(`/ajax/search/auto/${encodeURI(query)}`);
    }
}

export default SearchAutocompleteService;
